import React, { PureComponent } from 'react';

import './CheckoutOrderTotal.scss';

import { BasketPriceModel } from 'models/Basket';
import { formatCurrency } from 'formatters';
import { PaymentDetailsModel } from 'models/Payment';
import { paymentHelper } from 'helpers';

interface OwnProps {
    discounts: BasketPriceModel | null;
    paymentDetails: PaymentDetailsModel;
}

interface OwnPropsWithDefault {
    isDepositPaid?: boolean;
}

class CheckoutOrderTotal extends PureComponent<OwnProps & OwnPropsWithDefault> {
    static defaultProps: Partial<OwnPropsWithDefault> = {
        isDepositPaid: false
    };

    render() {
        const { discounts, isDepositPaid } = this.props;

        return (
            <div className='checkout-order-total'>
                {this.hasDiscount(discounts) && this.renderTotalDiscount()}
                {isDepositPaid && this.renderTotal()}
                {this.renderDeposit()}
                {
                    paymentHelper.isCardRelatedPaymentType(this.props.paymentDetails.paymentType)
                        ? this.renderRestCardPayment()
                        : this.renderRestIfcPayment()
                }
            </div>
        );
    }

    renderTotalDiscount(): JSX.Element {
        return (
            <div className='checkout-order-total__item'>
                <div className='checkout-order-total__title'>Total Discount:</div>
                <div className='checkout-order-total__value'>- {formatCurrency(this.props.discounts!.value)}</div>
            </div>
        );
    }

    renderTotal(): JSX.Element {
        return (
            <div className='checkout-order-total__item'>
                <div className='checkout-order-total__title'>Order Total:</div>
                <div className='checkout-order-total__value'>{formatCurrency(this.props.paymentDetails.total)}</div>
            </div>
        );
    }

    renderDeposit(): JSX.Element {
        const { isDepositPaid, paymentDetails } = this.props;
        const isCardRelatedPaymentType = paymentHelper.isCardRelatedPaymentType(paymentDetails.paymentType);
        const rest = paymentDetails.total - paymentDetails.cashCardDeposit;

        const deposit = isCardRelatedPaymentType
            ? paymentDetails.cashCardDeposit
            : paymentDetails.ifcDeposit;

        const depositTitle = isDepositPaid
            ? (isCardRelatedPaymentType ? 'Paid Today:' : 'Deposit Paid:')
            : (rest ? 'Amount to pay today:' : 'Total to pay today:');

        return (
            <div className='checkout-order-total__item'>
                <div className='checkout-order-total__title'>{depositTitle}</div>
                <div className='checkout-order-total__value'>{formatCurrency(deposit)}</div>
            </div>
        );
    }

    renderRestCardPayment(): JSX.Element | null {
        const { paymentDetails } = this.props;
        const rest = paymentDetails.total - paymentDetails.cashCardDeposit;

        if (!rest) {
            return null;
        }

        return (
            <div className='checkout-order-total__item'>
                <div className='checkout-order-total__title'>Balance to be paid before delivery:</div>
                <div className='checkout-order-total__value'>{formatCurrency(rest)}</div>
            </div>
        );
    }

    renderRestIfcPayment(): JSX.Element | null {
        const { paymentDetails } = this.props;

        return (
            <>
                <div className='checkout-order-total__item'>
                    <div className='checkout-order-total__title'>Total Finance Value:</div>
                    <div className='checkout-order-total__value'>{formatCurrency(paymentDetails.ifcMonthlyAmount * paymentDetails.ifcNumMonths)}</div>
                </div>

                <div className='checkout-order-total__item'>
                    <div className='checkout-order-total__title'>Monthly Payments:</div>
                    <div className='checkout-order-total__value'>{paymentDetails.ifcNumMonths} payments of {formatCurrency(paymentDetails.ifcMonthlyAmount)}</div>
                </div>
            </>
        );
    }

    hasDiscount(discount: BasketPriceModel | null) {
        return discount && discount.value > 0;
    }
}

export default CheckoutOrderTotal;